import { render, staticRenderFns } from "./BiometricsCreate.vue?vue&type=template&id=46697408"
import script from "./BiometricsCreate.vue?vue&type=script&lang=js"
export * from "./BiometricsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports